export default {
  scheduleEvent: 'Schedule Event',
};
